import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { default as PhoneModule, isValidPhoneNumber } from 'react-phone-number-input';

import 'react-phone-number-input/style.css';

class PhoneInput extends Component {
  state = {
    valid: null,
    currentPhone: '',
  }

  onChange = value => {
    const { setPhone } = this.props;

    if (value?.length) {
      if (!isValidPhoneNumber(value)) {
        this.setState({valid: false});
      }else{
        this.setState({valid: true});
        setPhone(value);
      }
    }else{
      this.setState({valid: null});
      setPhone('');
    }
  }

  render() {
    const { style, intl } = this.props;
    const { valid, currentPhone } = this.state;

    return (
      <div className={classNames(style.root, {[style.notValid]: valid === false, [style.valid]: valid === true})}>
        <PhoneModule
          international
          countryCallingCodeEditable={false}
          initialValueFormat="national"
          placeholder={intl.formatMessage({id: 'Login.PHONE'})}
          value={currentPhone}
          onChange={this.onChange}
          defaultCountry='UA'
          countries={['UA', 'MD']}
          minLength="16"
          maxLength="16"
          labels={{ 
            UA: intl.formatMessage({id: 'PhoneInput.UA'}),
            MD: intl.formatMessage({id: 'PhoneInput.MD'})
          }}
        />
      </div>
    )
  }
}

PhoneInput.defaultProps = {
  style: require('./PhoneInput.module.scss')
};

PhoneInput.propTypes = {
  setPhone: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
}

export default PhoneInput;